// Can't use `semver` package as Workano version aren't in semver format
const compareVersions = (a: string, b: string) => {
  let i;
  let diff;
  const regExStrip0 = /(\.0+)+$/;
  const segmentsA = a.replace(regExStrip0, '').split('.');
  const segmentsB = b.replace(regExStrip0, '').split('.');
  const l = Math.min(segmentsA.length, segmentsB.length);

  for (i = 0; i < l; i++) {
    diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);

    if (diff) {
      return diff;
    }
  }

  return segmentsA.length - segmentsB.length;
};

export default compareVersions;
